import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert, UncontrolledTooltip, Table, Spinner, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import Session from '../auth/Session';
import { FaSort } from 'react-icons/fa'
import utilities from '../util/utilities';
import { Typeahead } from 'react-bootstrap-typeahead';
import moment from "moment";

//Warm Gray - #5C5C5C
//Orange - #F26230 #FFFFFF
//Light Gray - #DDDDDD
//Almost Black - #373737
//backgroundColor: '#F26230', color: '#FFFFFF'

export class LeaseDetailsNotes extends Component {
    static displayName = LeaseDetailsNotes.name;

    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('id');

        this.state = {
            clientOptions: [],
            client: null,
            clientText: null,
            search: null,
            comments: [],
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100000,
            numberOfPages: 0,
            testType: 'Selection',
            testLevel: 'MA',
            leaseId: id,
            typeOptions: [{ label: "Status", value: "Status" },
            { label: "General", value: "General" },
            { label: "TI Note", value: "TI Note" }],
            lease: {} //For header
        };
        this.checkAuthenticated();
        this.GetLease(); //For header
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isWrite = false;
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isWrite = await AdminFunctions.isRole("Write");
        }
        this.setState({ isAdmin: isAdmin || isWrite });
    }

    async componentDidMount() {
        var _token = Session.getToken();
        //this.ShowAllLeases();
        this.GetSiteComments();
        //var data = [{ sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 1 },
        //    { sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 0 }];
        //this.setState({ rentTerms: data });
    }


    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.comments;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            valA = valA.toString(); //How do we fix?
            valB = valB.toString(); //How do we fix?
            return valA.localeCompare(valB);
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            comments: data,
            sort: {
                column,
                direction
            }
        })
    }
    handleSortInt(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.comments;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            //return valA.localeCompare(valB);
            if (valA < valB) {
                return -1;
            } else if (valA > valB) {
                return 1;
            } else {
                return 0;
            }
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            comments: data,
            sort: {
                column,
                direction
            }
        })
    }
    render() {

        // Logic for displaying comments
        const currentItems = this.state.comments;

        const renderItems = currentItems.map((candidate, i) => {
            return (
                <tr key={i} className={new Date(candidate.rt_start) < new Date() && new Date(candidate.rt_end) > new Date() ? 'highlightRow' : ''} >
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>
                                {candidate.com_type}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <select
                                    options={this.state.typeOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var commentsTemp = this.state.comments;
                                        commentsTemp[i].com_type = e.target.value;
                                        this.setState({ comments: commentsTemp });
                                    }}
                                    value={candidate.com_type}
                                    style={{ 'width': '163px' }}
                                >
                                    <option key=''></option>
                                    {this.state.typeOptions.map(option => {
                                        return (
                                            <option key={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>
                                {candidate.com_name}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>

                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>
                                {moment(candidate.com_date, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/yyyy")}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <input
                                    type="date"
                                    value={moment(candidate.com_date, "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD")}
                                    onChange={(e) => {
                                        var commentsTemp = this.state.comments;
                                        commentsTemp[i].com_date = e.target.value;
                                        commentsTemp[i].com_timestamp = e.target.value;
                                        this.setState({ comments: commentsTemp });
                                    }}
                                    name="com_date"
                                    id='com_date'
                                    style={{ 'width': '113px' }}
                                />
                            </div>
                        )}
                    </td>

                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>
                                {candidate.com_text}
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <div>
                                <textarea
                                    type="textarea"
                                    value={candidate.com_text}
                                    onChange={(e) => {
                                        var commentsTemp = this.state.comments;
                                        commentsTemp[i].com_text = e.target.value;
                                        this.setState({ comments: commentsTemp });
                                    }}
                                    name="com_text"
                                    id='com_text'
                                    style={{ 'height': '80px', 'width': '609px' }}
                                />
                            </div>
                        )}
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        {candidate.editMode === false && (
                            <div>

                                <Button
                                    color='primary'
                                    onClick={() => {
                                        var commentsTemp = this.state.comments;
                                        commentsTemp[i].prevTerms = Object.assign({}, commentsTemp[i]);
                                        commentsTemp[i].editMode = true;
                                        this.setState({ comments: commentsTemp });
                                    }}
                                    className="g-orange-bg g-orange-c g-orange-button gButton"
                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                    disabled={this.state.loading === true ? true : false}
                                    hidden={!this.state.isAdmin ? true : false}
                                >
                                    Edit
                                </Button>
                            </div>
                        )}
                        {candidate.editMode === true && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    var commentsTemp = this.state.comments;
                                    if (this.IsEmpty(candidate) === true) {
                                        this.DeleteEmpty(i);
                                    }
                                    else {
                                        this.SaveComments(candidate, i);
                                    }

                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                {this.IsEmpty(candidate) === false ? 'Save' : 'Delete'}
                            </Button>
                        )}
                        {candidate.editMode === true && candidate.rt_id !== 0 && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    var commentsTemp = this.state.comments;
                                    commentsTemp[i] = commentsTemp[i].prevTerms;
                                    commentsTemp[i].prevTerms = {};
                                    commentsTemp[i].editMode = false;
                                    this.setState({ comments: commentsTemp });

                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                Cancel
                            </Button>
                        )}
                        {candidate.editMode === true && candidate.rt_id !== 0 && (
                            <Button
                                color='primary'
                                onClick={() => {
                                    this.DeleteExisting(candidate, i);
                                }}
                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                disabled={this.state.loading === true ? true : false}
                                hidden={!this.state.isAdmin ? true : false}
                            >
                                Delete
                            </Button>
                        )}
                    </td>
                </tr>
            )
        });

        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Lease Details</h3>
                </div>
                <div id="body" className="g-warm-gray-c">
                    <Row>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>
                            <label className="g-almost-black-c addressTitle">
                                {this.state.lease.sd_address}<br />
                                {this.state.lease.sd_city}, {this.state.lease.sd_state} {this.state.lease.sd_zip}
                            </label> {/*//For header*/}
                        </Col>
                    </Row>
                    <Row className="g-warm-gray-bg g-warm-gray-c" style={{ 'textAlign': 'center' }}>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Summary?id=' + this.state.leaseId}
                            >
                                Summary
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-RentTerms?id=' + this.state.leaseId}
                            >
                                Rent Terms
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-CriticalDates?id=' + this.state.leaseId}
                            >
                                Critical Dates
                            </NavLink>
                        </Col>
                        <Col className="g-orange-bg g-orange-c">
                                Notes
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Documents?id=' + this.state.leaseId}
                            >
                                Documents
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Contacts?id=' + this.state.leaseId}
                            >
                                Contacts
                            </NavLink>
                        </Col>
                    </Row>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row className="rowSpacing">
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '100px' }}>
                                            Type
                                            <FaSort
                                                color={this.state.sort.column === 'comm_type' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('comm_type')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '106px' }}>
                                            Name
                                            <FaSort
                                                color={this.state.sort.column === 'com_name' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('com_name')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '106px' }}>
                                            Date
                                            <FaSort
                                                color={this.state.sort.column === 'com_date' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('com_date')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '114px' }}>
                                            Notes
                                            <FaSort
                                                color={this.state.sort.column === 'com_text' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('com_text')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c buttonColumn" style={{ 'width': '106px' }}>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <tr>
                                            <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                <Spinner color="primary" children='' />
                                            </td>
                                        </tr>

                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                            <td className="rightAlignButtons">
                                                            <Button
                                                                color='primary'
                                                                onClick={() => {
                                                                    this.AddRows(1);
                                                                }}
                                                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                                    disabled={this.state.loading === true ? true : false}
                                                                    hidden={!this.state.isAdmin ? true : false}
                                                            >
                                                                Add
                                                                </Button>
                                                                <Link
                                                                    to="/Lease/ActiveLeases?search=1"
                                                                    color='primary'
                                                                    className="g-orange-bg g-orange-c g-orange-button gButton btn btn-primary"
                                                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", padding: '5px' }}
                                                                    disabled={this.state.loading === true ? true : false}
                                                                >
                                                                    Back To List
                                                                </Link>
                                                        </td>
                                                    </tr>
                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <h5>No Results Found</h5>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    async GetSiteComments() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetSiteComments?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        })
        const data = await response.json();
        this.setState({ comments: data });
    }

    AddRows(number) {
        for (var i = 0; i < number; i++) {
            var newRow = { com_id: 0, site_id: this.state.leaseId, com_type: '', com_text: '', com_user_id: '', com_date: null, com_timestamp: null, com_name: '', editMode: true, active: true };
            //var newRow = { rt_id: 0, sd_id: this.state.leaseId, site_details: null, rt_type: '', rt_start: null, rt_end: null, rt_months: null, rt_monthly: null, rt_annual: null, rt_psqft: null, rt_notes: null, editMode: true };
            var commentsTemp = this.state.comments;
            commentsTemp.push(newRow);
            this.setState({ comments: commentsTemp });
        }
    }
    IsEmpty(candidate) {
        if (candidate.com_text || candidate.com_type || candidate.com_date) {
            //If anything is filled out, it's not empty.
            return false;
        }
        if (candidate.com_id) {
            //If it's not a new item, it's not considered empty for this.
            return false;
        }
        return true;
    }
    DeleteEmpty(index) {
        var commentsTemp = this.state.comments;
        commentsTemp.splice(index, 1);
        this.setState({ comments: commentsTemp });
    }
    async SaveComments(candidate, index) {
        if (this.IsValid(candidate))
        {
            if (!candidate.com_date) {
                candidate.com_date = new Date();
            }
            const token = Session.getToken();
            const response = await fetch('api/Leases/EditSiteComments', {
                method: 'POST',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(candidate)
            });

            const data = await response.json();

            if (data) {
                if (data.com_id > 0) {
                    var commentsTemp = this.state.comments;
                    commentsTemp[index].com_id = data.com_id;
                    commentsTemp[index].com_name = data.com_name;
                    commentsTemp[index].editMode = false;
                    this.setState({ contacts: commentsTemp });
                }
            }
        }
        
    }
    async DeleteExisting(candidate, index) {
        if (window.confirm("Are you sure you want to delete this Note?") === true) {
            const token = Session.getToken();
            const response = await fetch('api/Leases/DeleteSiteComments?id=' + candidate.com_id, {
                method: 'GET',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            })

            var commentsTemp = this.state.comments;
            commentsTemp.splice(index, 1);
            this.setState({ comments: commentsTemp });
        }
    }
    //For header
    async GetLease() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetLease?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },

        })
        const data = await response.json();
        this.setState({ lease: data });
    }

    IsValid(comment) {
        if (!comment) {
            alert("Comment can't be blank.");
            return false;
        }
        //if (!comment.c_type) {
        //    alert("Comment type is required.");
        //    return false;
        //}
        if (!comment.com_date) {
            alert("Comment date is required.");
            return false;
        }
        return true;
    }
}

